export const version = '2.36.0';
//# sourceMappingURL=version.js.map